import React, { FC, ReactChildren } from 'react'
import cn from 'classnames'
import moment from 'moment'
import { STATUS_LIST } from '../../constants'

interface Props {
  date: Date | null,
  status?: string,
  children: string
}

const OrderDateFormatter: FC<Props> = ({date, status, children, type, picked_up, expiration_date, row}) => {
  let color = "text-blue-500";

  if (date) {
    color = "";
    if (type === "delivery_date") {  // Arrived for Pickup
      if (row['Initial Estimated Delivery Date']) {
        const startDateUnix = new Date(row['Initial Estimated Delivery Date']).getTime() / 1000
        const endDateUnix = new Date(date).getTime() / 1000
        const delayInDays = (endDateUnix - startDateUnix) / 86400
        if (delayInDays > 1) {
          color = "text-red-500";
        } else if (delayInDays > 0) {
          color = "text-yellow-500"
        }
      }
    } else if (type === "delivery_complete") {
      const pickedUpdiff = (moment(expiration_date).diff(moment(date), "hours") / 24)
      if (pickedUpdiff <= 1) {
        color = "text-red-500";
      } else if (pickedUpdiff <= 3) {
        color = "text-yellow-500";
      }
    } else if (type == "expiration_date") {
      const diff = (moment(date).diff(moment(), "hours") / 24)
      if (row?.status !== 'PICKED_UP') {
        if (diff <= 1) {
          color = "text-red-500"
        } else if (diff <= 3) {
          color = "text-yellow-500"
        }
      }
    }
  }

  return (
    <span className={color}>
      {children}
    </span>
  )
}

export default OrderDateFormatter